export const typeOptions = [
    { label: "Treatment Plan", value: "treatment_plan" },
    { label: "Diagnostic Protocol", value: "diagnostic_protocol" },
    { label: "Medication Regimen", value: "medication_regimen" },
    { label: "Rehabilitation Program", value: "rehabilitation_program" },
    { label: "Preventive Care", value: "preventive_care" },
];